import React from 'react';
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { callService, goTo } from '../tools';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import { servicios } from "./../properties";
import firebase from 'firebase';
const mapState = (state) => {
    return {
        email: state.olvideContrasenia.email,
        paso: state.olvideContrasenia.paso,
    };
}

const mapDispatch = (dispatch) => {
    return {
        setEmail: (correo) => {
            dispatch({ "type": "SET_EMAIL", "email": correo });
        },
        setPaso: (paso) => {
            dispatch({ "type": "PASO_SIGUIENTE_OLVIDE_CONTRASENIA", "paso": paso });
        },
        loader: (show) => {
            dispatch({ "type": "LOADER", "show": show });
        }
    }
}

class OpcionesOlvideContrasenia extends React.Component {

    state = {
        MsjTiempoRestante: true,
        MsjExpira: false,
        msjErrorCodigo: false,
        msjExitoReenvio: false,
        msjErrorServicio: false,
        btnValidarHabilitado: true,
        celular: "",
        showTooltip: false,
        mensaje: "",
        type: "",
        titulo: "",
        loadingPequeno: false,
        uidEncriptado: "",
        email: "",
        cveUnico: "",
        errorsCodigo: false,
        msjaMostrar: "",
        showInput: true,
        name: "",
        label: "",
    }
    arrayCodigosOtp = [];
    btnHabilitado = false;

    regresar = () => {

        firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
            var data = oValue.val();
            if (!data) {
                goTo("login");
            } else {
                window.location.assign(servicios.dominioReingenieria);
            }
        })
    }

    generarPassword = () => {
        this.props.loader(true);
        let caracteresFinales1 = '';
        let caracteresFinales2 = '';
        let caracteresFinales3 = '';
        let caracteresFinales4 = '';
        let caracteresFinales5 = '';
        let caracteresFinales6 = '';
        let caracteresFinales7 = '';
        let password1 = '';
        let password2 = '';
        let password3 = '';
        let password4 = '';
        let password5 = '';
        let password6 = '';
        let password7 = '';

        const caracteres = {
            numeros: '0 1 2 3 4 5 6 7 8 9',
            simbolos: '! @ # $ % ^ & * ( ) _ - + = { [ } ] ; : < , > . /',
            mayusculas: 'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z',
            minusculas: 'a b c d e f g h i j k l m n o p q r s t u v w x y z'
        }

        caracteresFinales1 += caracteres.mayusculas;
        caracteresFinales1 = caracteresFinales1.trim();
        caracteresFinales1 = caracteresFinales1.split(' ');

        for (let i = 0; i < 1; i++) {
            password1 += caracteresFinales1[Math.floor(Math.random() * caracteresFinales1.length)];
        }

        caracteresFinales2 += caracteres.simbolos;
        caracteresFinales2 = caracteresFinales2.trim();
        caracteresFinales2 = caracteresFinales2.split(' ');

        for (let i = 0; i < 1; i++) {
            password2 += caracteresFinales2[Math.floor(Math.random() * caracteresFinales2.length)];
        }

        caracteresFinales3 += caracteres.minusculas;
        caracteresFinales3 = caracteresFinales3.trim();
        caracteresFinales3 = caracteresFinales3.split(' ');

        for (let i = 0; i < 2; i++) {
            password3 += caracteresFinales3[Math.floor(Math.random() * caracteresFinales3.length)];
        }

        caracteresFinales4 += caracteres.numeros;
        caracteresFinales4 = caracteresFinales4.trim();
        caracteresFinales4 = caracteresFinales4.split(' ');

        for (let i = 0; i < 1; i++) {
            password4 += caracteresFinales4[Math.floor(Math.random() * caracteresFinales4.length)];
        }

        caracteresFinales5 += caracteres.mayusculas;
        caracteresFinales5 = caracteresFinales5.trim();
        caracteresFinales5 = caracteresFinales5.split(' ');

        for (let i = 0; i < 1; i++) {
            password5 += caracteresFinales5[Math.floor(Math.random() * caracteresFinales5.length)];
        }

        caracteresFinales6 += caracteres.numeros;
        caracteresFinales6 = caracteresFinales6.trim();
        caracteresFinales6 = caracteresFinales6.split(' ');

        for (let i = 0; i < 1; i++) {
            password6 += caracteresFinales6[Math.floor(Math.random() * caracteresFinales6.length)];
        }

        caracteresFinales7 += caracteres.simbolos;
        caracteresFinales7 = caracteresFinales7.trim();
        caracteresFinales7 = caracteresFinales7.split(' ');

        for (let i = 0; i < 1; i++) {
            password7 += caracteresFinales7[Math.floor(Math.random() * caracteresFinales7.length)];
        }

        const passwordFinal = password1 + password2 + password3 + password4 + password5 + password6 + password7;

        localStorage.setItem("newPass", passwordFinal);


        setTimeout(() => {
            this.props.loader(false);
            this.props.setPaso(1);
        }, 2000);
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
        setTimeout(() => {
            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
        }, 300);
    }

    cierraTooltip = e => {
        this.setState({
            showTooltip: !this.state.showTooltip
        });
    }

    mostrarSpinner = (bandera) => {
        if (bandera) {
            setTimeout(() => {
                this.setState({ loadingPequeno: true });
            }, 500);
        } else {
            setTimeout(() => {
                this.setState({ loadingPequeno: false });
            }, 500);
        }
    }

    siguiente = () => {
        this.props.loader(true);
        localStorage.removeItem("newPass");

        setTimeout(() => {
            this.props.loader(false);
            this.props.setPaso(1);
        }, 2000);
    }

    render() {

        return (
            <div id='opcionesOlvide' className="txt-center" style={{ height: "510px", background: '#FFFFFF' }}>

                <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
                    show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
                </ModalSintillo>

                <div className='div-title-olv'>
                    <span className="material-icons bi bi-arrow-left" style={{ float: "left", cursor: "pointer", marginTop: "20px" }} onClick={this.regresar}>
                        arrow_back
                    </span>
                    <label id="txt-title-olvide">Recuperar contraseña</label>
                    <br />
                    <hr className="label-hr" />
                </div>
                <div className='div-opciones-olv'>
                    <div className='div-titulo-opciones-olv'>
                        <span className='subtitulo-Olvide-op'>¿De qué forma deseas recuperar tu contraseña?</span>
                    </div>
                    <div className='contenedor-opciones-olv'>
                        <div className='div-btn-establecer'>
                            <button className='div-establecer' onClick={this.siguiente}>
                                <div className='div-icons'>
                                    <div className='div-icon1'>
                                        <span id='candado' className="material-icons bi icon-lock">
                                        </span>
                                    </div>
                                    <div className='div-icon2'>
                                        <span id='flecha1' className="material-icons bi icon-arrow-right">
                                        </span>
                                    </div>
                                </div>
                                <div className='div-texto-opciones'>
                                    <p className='titulo-opciones'>Establecer nueva contraseña</p>
                                    <p className='parrafo-opciones'>Te enviaremos un enlace por correo para
                                        que establezcas una nueva contraseña.</p>
                                </div>
                            </button>
                        </div>
                        <div className='div-btn-provicional'>
                            <button className='div-provicional' onClick={this.generarPassword}>
                                <div className='div-icons-2'>
                                    <div className='div-icon1'>
                                        <span id='llave' className="material-icons bi icon-key">
                                        </span>
                                    </div>
                                    <div id='flecha2' className='div-icon2'>
                                        <span className="material-icons bi icon-arrow-right">
                                        </span>
                                    </div>
                                </div>
                                <div className='div-texto-opciones'>
                                    <p className='titulo-opciones'>Clave de acceso temporal</p>
                                    <p className='parrafo-opciones'>Se enviará una contraseña temporal
                                        al número guardado anteriormente, pero
                                        deberás cambiarla después.</p>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>

            </div>);
    }
}
OpcionesOlvideContrasenia = reduxForm({ form: "opcionesOlvideContrasenia" })(OpcionesOlvideContrasenia);
export default connect(mapState, mapDispatch)(OpcionesOlvideContrasenia);



// WEBPACK FOOTER //
// ./src/gnp-olvide-contrasenia/opcionesOlvideContrasenia.frm.js